import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { BulkActionJobSummaryDto } from './bulkActions.types';

const ENDPOINT = `${APIConfiguration.search}bulkActions`;

export interface GetBulkActionJobsQueryArgs {
  tenantId?: string;
  sellerId?: string;
}

async function getBulkActionJobsQuery({
  tenantId,
  sellerId,
}: GetBulkActionJobsQueryArgs = {}): Promise<
  BackResponse<BulkActionJobSummaryDto[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, {
      TenantId: tenantId,
      SellerId: sellerId,
    });

    return await apiCall<BackResponse<BulkActionJobSummaryDto[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getBulkActionJobsQuery;
